import serverInterface from 'server-interface';

import types from './elements/types';

function collectGalleryNodes(node, accumulator) {

  if (node === null || typeof node !== 'object') {
    return;
  }

  if (node.type === types.GALLERY) {
    accumulator.push(node);
    return;
  }

  if (node.type === types.GALLERY_ITEM) {
    accumulator.push(node);
    return;
  }

  if (Array.isArray(node.children) === false) {
    return;
  }

  for (let child of node.children) {
    collectGalleryNodes(child, accumulator);
  }

}

function markNodeForDeletion(node) {

  const properties = node.properties || {};

  if (node.type === types.GALLERY) {

    if (typeof properties.galleryId !== 'string') {
      return;
    }

    serverInterface.startup.pages.markGalleryForDeletion(properties.galleryId);
    return;

  }

  if (typeof properties.galleryItemId !== 'string' || typeof properties.galleryId !== 'string') {
    return;
  }

  serverInterface.startup.pages.markGalleryItemForDeletion(properties.galleryId, properties.galleryItemId);

}

function unmarkNodeForDeletion(node) {

  const properties = node.properties || {};

  if (node.type === types.GALLERY) {

    if (typeof properties.galleryId !== 'string') {
      return;
    }

    serverInterface.startup.pages.unmarkGalleryForDeletion(properties.galleryId);
    return;

  }

  if (typeof properties.galleryItemId !== 'string' || typeof properties.galleryId !== 'string') {
    return;
  }

  serverInterface.startup.pages.unmarkGalleryItemForDeletion(properties.galleryId, properties.galleryItemId);

}

export default function trackGalleryResources(editor) {

  const operations = editor.operations;

  for (let operation of operations) {

    const operationType = operation.type;

    if (operationType !== 'remove_node' && operationType !== 'insert_node') {
      continue;
    }

    const accumulator = [];

    collectGalleryNodes(operation.node, accumulator);

    for (let node of accumulator) {

      if (operationType === 'remove_node') {
        markNodeForDeletion(node);
      } else {
        unmarkNodeForDeletion(node);
      }

    }

  }

}